import React from 'react';

import type IScenarioShowcaseInfo from './interfaces/IScenarioShowcaseInfo';

import styles from './scss/ScenarioShowcaseInfo.module.scss';

function ScenarioShowcaseInfo({ rows }: IScenarioShowcaseInfo): React.JSX.Element | null {
  if (rows.length === 0) {
    return null;
  }

  return (
    <div className={styles.infoSection}>
      {rows.map(({ label, value }) => (
        <div key={label} className={styles.infoRow}>
          <span className={styles.infoLabel}>
            {label}
            :
          </span>
          <span className={styles.infoValue}>{value}</span>
        </div>
      ))}
    </div>
  );
}

export default ScenarioShowcaseInfo;
